import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

function emptyFunction() {}

var AccessibilityInfo = {
  fetch: function fetch() {
    return new Promise(function (resolve, reject) {
      resolve(true);
    });
  },
  addEventListener: function addEventListener(eventName, handler) {
    return {
      remove: emptyFunction
    };
  },
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
  announceForAccessibility: function announceForAccessibility(announcement) {},
  removeEventListener: function removeEventListener(eventName, handler) {
    return;
  }
};
export default AccessibilityInfo;